/**
 * useResponsive — détecte si on est sur un écran "desktop" (web large).
 *
 * - Sur native (iOS/Android), retourne toujours { isDesktopWeb: false }.
 * - Sur web, retourne true si la viewport fait >= DESKTOP_BREAKPOINT.
 * - Listener resize : se met à jour si l'utilisateur redimensionne la fenêtre.
 *
 * v1.12.117 — adaptation web app desktop (Option B).
 */

import { useEffect, useState } from 'react';
import { Dimensions, Platform } from 'react-native';

export const DESKTOP_BREAKPOINT = 768;

function getCurrentIsDesktop() {
  if (Platform.OS !== 'web') return false;
  const w = Dimensions.get('window').width || 0;
  return w >= DESKTOP_BREAKPOINT;
}

export function useResponsive() {
  const [isDesktopWeb, setIsDesktopWeb] = useState(getCurrentIsDesktop);

  useEffect(() => {
    if (Platform.OS !== 'web') return undefined;
    const sub = Dimensions.addEventListener('change', () => {
      setIsDesktopWeb(getCurrentIsDesktop());
    });
    return () => {
      try { sub?.remove?.(); } catch {}
    };
  }, []);

  return { isDesktopWeb };
}

export default useResponsive;
